import gql from 'graphql-tag'

export const newTask = gql`
  mutation newTask(
    $name: String!
    $isCompleted: Boolean!
    $minutesTotal: Int
    $minutesSpent: Int
    $progressPercentage: Int
    $trackerId: ID!
    $userId: ID!
  ) {
    createTask(
      name: $name
      isCompleted: $isCompleted
      minutesTotal: $minutesTotal
      minutesSpent: $minutesSpent
      progressPercentage: $progressPercentage
      trackerId: $trackerId
      userId: $userId
    ) {
      id
    }
  }
`

export const updateCurrentTask = gql`
  mutation updateCurrentTask(
    $currentId: String
    $currentName: String
    $id: ID!
    $userId: ID!
  ) {
    updateTask(
      currentId: $currentId
      currentName: $currentName
      id: $id
      userId: $userId
    ) {
      id
    }
  }
`

export const updateTask = gql`
  mutation updateTask(
    $name: String!
    $isCompleted: Boolean!
    $minutesTotal: Int
    $minutesSpent: Int
    $progressPercentage: Int
    $trackerId: ID!
    $userId: ID!
    $id: ID!
  ) {
    updateTask(
      name: $name
      isCompleted: $isCompleted
      minutesTotal: $minutesTotal
      minutesSpent: $minutesSpent
      progressPercentage: $progressPercentage
      trackerId: $trackerId
      userId: $userId
      id: $id
    ) {
      id
    }
  }
`

export const deleteTask = gql`
  mutation deleteTask($id: ID!) {
    deleteTask(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/task.js